<template>
  <b-card>

    <h3 class="text-center mb-1">
      {{ $t("Find an organization by directions") }}
    </h3>
    <div v-if="loading">
      <div class="d-flex justify-content-center mb-5">
        <b-spinner
          variant="primary"
          label="Text Centered"
        />
      </div>
    </div>
    <div v-else>
      <b-row class="mb-2">
        <b-col cols="12">
          <v-select
            id="direction"
            v-model="direction"
            :reduce="(option) => option.code"
            :options="directions"
            :get-option-label="(option) => option.code + '-' +$langName(option.name)"
            :placeholder="$t('Direction')"
            @input="search()"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-table
          ref="districtTable"
          class="px-1"
          :items="organizationOfDirection"
          responsive
          :fields="tableColumns"
          primary-key="id"
        >
          <template #head()="data">
            {{ $t(data.label) }}
          </template>

          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(name)="data">
            {{ $langName(data.value) }}
          </template>

        </b-table>
      </b-row>
    </div>

  </b-card>
</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import {
  BCard, BRow, BCol,
  BSpinner, BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import statisticModule from '@/store/statistic'
import directionModule from '@/store/direction'

export default {
  name: 'FindOrgByDirection',
  components: {
    BCard,
    BRow,
    BCol,
    BSpinner,
    BTable,
    vSelect,
  },
  data() {
    return {
      direction: null,
      loading: true,
    }
  },
  computed: {
    organizationOfDirection() {
      return this.$store.state[this.MODULE_STATISTIC].organizationOfDirection
    },
    directions() {
      return this.$store.state[this.MODULE_DIRECTION].directions
    },
  },
  created() {
    this.$store.dispatch(`${this.MODULE_DIRECTION}/list`, {
      limit: this.MAX_LIMIT,
    })
    this.refetchData()
  },
  methods: {
    refetchData() {
      this.loading = true
      this.$store.dispatch(`${this.MODULE_STATISTIC}/findOrgByDirection`, {
        direction: this.direction,
      }).finally(() => {
        this.loading = false
      })
    },
    search() {
      this.refetchData()
    },
  },
  setup() {
    const tableColumns = [
      { key: 'index', label: '#' },
      { key: 'name', label: 'name', sortable: true },
    ]
    const MODULE_STATISTIC = 'statistic-front-find'
    const MODULE_DIRECTION = 'direction-front'
    // Register module
    if (!store.hasModule(MODULE_STATISTIC)) store.registerModule(MODULE_STATISTIC, statisticModule)
    if (!store.hasModule(MODULE_DIRECTION)) store.registerModule(MODULE_DIRECTION, directionModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_STATISTIC)) store.unregisterModule(MODULE_STATISTIC)
      if (store.hasModule(MODULE_DIRECTION)) store.unregisterModule(MODULE_DIRECTION)
    })

    return {
      MODULE_STATISTIC,
      MODULE_DIRECTION,
      tableColumns,
    }
  },
}
</script>

<style scoped>

</style>
